import { getTelemetryClient } from 'smash-telemetry';
import { environment } from '../../../environments/environment';
import { scrubHttpErrorForTelemetry } from './scrubHttpErrorForTelemetry';

/**
 * Initializes and starts the shared `smash-telemetry` client, browser-only, from this
 * environment's configuration. No consent gate: telemetry here is error/console/Web Vitals
 * observability, not marketing analytics, so it runs unconditionally.
 *
 * `beforeSend` is wired to {@link scrubHttpErrorForTelemetry} so an `HttpErrorResponse` captured
 * through `GlobalErrorHandler` never leaves the browser with its request URL, query string or
 * response body intact -- `smash-telemetry`'s ingestion endpoint is unauthenticated.
 */
export function bootstrapTelemetry(): void {
    const client = getTelemetryClient();
    client.init({
        logGroup: environment.telemetry.logGroup,
        stream: environment.telemetry.stream,
        baseUrl: environment.telemetry.baseUrl,
        enabled: environment.telemetry.enabled,
        beforeSend: scrubHttpErrorForTelemetry,
    });
    client.start();
}
